/* eslint-disable no-underscore-dangle */
export default {
  getThumbnail(img, size = 500, { cropped = false, css = false } = {}) {
    const thumb = this._getUrl(img, size, cropped);
    return (css) ? this._css(thumb) : thumb;
  },
  _css(url) {
    return (url) ? `url(${url})` : 'none';
  },
  _getUrl(img, size, cropped) {
    if (!img) return null;
    const imgRelativePath = img.url.replace(/^\//, '');
    if (img.is_animated_gif) return `${process.env.VUE_APP_CMS_URL}/${imgRelativePath}`;
    return `${process.env.VUE_APP_CMS_URL}/${imgRelativePath.replace(/([^.]*)\.(jpe?g|png|gif)$/, `$1.${size}${(cropped) ? '-cropped' : ''}.$2`)}`;
  },
};
